<template>
  <div class="scpPage">
    <div class="secondOperation">
      <div>
        <i-button @click="getData">
          <i class="iconfont icon-refresh"></i>
          刷新
        </i-button>
        <i-button
          @click="showLog = true"
          style="margin-left: 15px"
          type="primary"
        >
          查看日志
        </i-button>
      </div>
      <div style="display: flex; align-items: center">
        <i-switch
          v-model="isOpen"
          @on-change="changeSwitch"
          size="small"
          style="margin: 8px 20px 0 0px"
        ></i-switch>
        <div class="status">
          {{
            result.serviceStatus == 10
              ? "启 用"
              : result.serviceStatus == 11
              ? "启 用 中"
              : result.serviceStatus == 21
              ? "禁 用 中"
              : "禁 用"
          }}
        </div>
      </div>
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        C-Store SCU服务基本信息
        <Poptip
          content="远端服务器和其他服务器的连接服务"
          placement="right"
          class="tip"
          trigger="hover"
          style="margin-left: 10px"
        >
          <Icon type="md-alert" />
        </Poptip>
      </div>
      <!-- <div style="display: flex;justify-content: space-between;">
        <div class="log" @click="showLog = true">查看日志</div><i-switch v-model="isOpen" @on-change="changeSwitch"
          size="small" style="margin: 8px 0 0 0;"></i-switch>
      </div> -->
    </div>
    <div class="des">
      <div class="serDes">
        <span class="secondTit">服务描述：</span>{{ result.description }}
      </div>
      <!-- <div>
        <span class="secondTit">更新时间：</span>{{ result.updateTime }}
      </div> -->
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        基础配置
      </div>
    </div>
    <div class="des">
      <Form :label-width="120" inline>
        <FormItem label="一轮休眠时长(秒)">
          <InputNumber
            :min="0"
            placeholder="请输入"
            v-model="baseData.interval"
            clearable
          ></InputNumber>
        </FormItem>

        <FormItem label="启用时间">
          <DatePicker
            :value="selectTime"
            type="date"
            placeholder="请选择日期"
            style="width: 200px"
            @on-change="changeTime"
          ></DatePicker>
          <Poptip
            content="填写需要发送最早影像的检查时间"
            placement="right"
            class="tip"
            trigger="hover"
            style="margin-left: 10px"
          >
            <Icon type="md-alert" />
          </Poptip>
        </FormItem>
        <FormItem label="是否打印SQL">
          <Radio-group v-model="baseData.isPrintSql">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </Radio-group>
        </FormItem>
        <FormItem label="最大线程数">
          <Select v-model="baseData.threadCount" style="width: 184px">
            <Option v-for="item in 5" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="日志级别">
          <Select v-model="baseData.logLevel" style="width: 200px">
            <Option
              v-for="item in LogsData"
              :value="item.key"
              :key="item.key"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <Button class="ml-5 mr-5" type="primary" @click="SetScuConfig"
        >确定</Button
      >
      <Button @click="cancelEdit">重置</Button>
      <div></div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <div class="second">
        <div class="tit">
          <div class="line"></div>
          SCU AE列表
        </div>
        <Table
          border
          width=""
          highlight-row
          :columns="columns"
          :data="data.ScuAeList"
        ></Table>
      </div>
      <div class="second" style="margin-left: 20px">
        <div class="tit">
          <div class="line"></div>
          编辑C-Store SCU参数
        </div>
        <div class="secOperation">
          <Form :label-width="90" inline>
            <FormItem label="节点名称">
              <Input
                placeholder="请输入"
                v-model="params.ScuName"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="本地AE">
              <Input
                placeholder="请输入"
                v-model="params.AEing"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="目标IP">
              <Input placeholder="请输入" v-model="params.Ip" clearable></Input>
            </FormItem>
            <FormItem label="目标AE">
              <Input
                placeholder="请输入"
                v-model="params.AEed"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="目标端口">
              <Input
                placeholder="请输入"
                v-model="params.Port"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="启用状态">
              <Radio-group v-model="params.IsStart">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </Radio-group>
            </FormItem>
          </Form>
          <div class="btnGroup">
            <Button class="cancel" @click="clear">重置</Button>
            <Button type="primary" @click="addOrEidt('save')">{{
              btnName
            }}</Button>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-model="showLog"
      title="C-Store SCU服务日志"
      :footer-hide="true"
      :width="1000"
    >
      <log v-if="showLog" @close="showLog = false" :from="'scu'"></log>
    </Modal>
  </div>
</template>
<script>
import log from "./log.vue";
export default {
  components: { log },
  data() {
    return {
      selectTime: "",
      params: {
        ScuName: "",
        Ip: "",
        Port: "",
        AEing: "",
        AEed: "",
        IsStart: 0,
      },
      LogsData: [],
      baseData: {},
      oldBaseData: {},
      serviceSign: "",
      isOpen: false,
      showLog: false,
      data: {
        ScuAeList: [],
      },
      result: {},
      btnName: "新增",
      status: 10,
      columns: [
        { title: "IP", key: "Ip", align: "center" },
        { title: "节点名称", key: "ScuName", align: "center" },
        { title: "端口", key: "Port", align: "center" },
        { title: "本地AE", key: "AEing", align: "center" },
        { title: "服务AE", key: "AEed", align: "center" },
        {
          title: "启用状态",

          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                },
                params.row.IsStart == true ? "启用" : "禁用"
              ),
            ]);
          },
        },
        {
          title: "操作",
          // width: "200px",
          // fixed: "right",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.addOrEidt("edit", params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.delete(params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
  methods: {
    changeTime(e) {
      console.log(e);
      this.selectTime = e;
      console.log(this);
    },
    //获取日志
    // getLogs() {
    //   this.$api.get('dictionary/GetLogConfigurationEnum').then((res) => {
    //     this.LogsData = res.data
    //   })
    // },
    SetScuConfig() {
      // this.baseData.startTime = this.selectTime[0];
      // this.baseData.endTime = this.selectTime[1];
      this.baseData.startTime = this.selectTime;
      this.$api
        .post("/ServiceInfo/updateScuBaseConfig", {
          ...this.baseData,
          isPrintSql: this.baseData.isPrintSql == 1 ? true : false,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success("修改成功");
            this.getScuConfig();
          }
        });
    },
    cancelEdit() {
      // this.baseData = this.oldBaseData;
      this.getScuConfig();
    },
    getScuConfig() {
      this.$api.get("ServiceInfo/getScuBaseConfig").then((res) => {
        //console.log('-------------------',res);
        this.baseData = res.data;
        this.baseData.isPrintSql = this.baseData.isPrintSql ? 1 : 0;
        // this.selectTime.push(this.baseData.startTime, this.baseData.endTime);
        // this.$set(this.selectTime, 0, this.baseData.startTime);
        // this.$set(this.selectTime, 1, this.baseData.endTime);
        this.selectTime = this.baseData.startTime;
        this.oldBaseData = JSON.parse(JSON.stringify(this.baseData));
        console.log(this.baseData);
      });
    },

    changeSwitch(val) {
      this.isOpen = val;
      this.$api
        .post("dictionary/updateServiceStatus", {
          serviceSign: this.serviceSign,
          serviceStatus: this.isOpen,
        })
        .then((res) => {
          if (!res) {
            this.Status = this.result.serviceStatus;
            this.isOpen = !this.isOpen;
            this.timer = setInterval(() => {
              this.getData();
            }, 10000);
          } else {
            this.getData();
          }
        });
    },
    getData() {
      this.$api.get(`ServiceInfo/scuConfig`).then((res) => {
        console.log(res,444);
        this.serviceSign = res.data.serviceSign;
        this.result = res.data;
        this.isOpen = res.data.serviceStatus === 10;
        this.data = Object.assign({}, JSON.parse(res.data.serviceParams));
      });
    },
    clear() {
      this.btnName = "新增";
      this.params.Ip = "";
      this.params.Port = "";
      this.params.AEing = "";
      this.params.AEed = "";
      this.params.ScuName = "";
      this.params.IsStart = 0;
      this.getData();
    },
    delete(data) {
      this.$Modal.confirm({
        title: "确认要删除么？",
        mask: false,
        onOk: () => {
          this.data.ScuAeList.splice(data._index, 1);
          this.saveData();
        },
      });
    },
    addOrEidt(type, data) {
      if (type == "edit") {
        this.params = Object.assign({}, data);
        this.params.IsStart = Number(data.IsStart);
        this.btnName = "保存";
        // this.params.EndTime='2030-1-24'
      }
      if (type == "save") {
        if (this.btnName == "保存") {
          //编辑状态
          this.data.ScuAeList.splice(this.params._index, 1);
        }
        this.data.ScuAeList.push({
          ...this.params,
          IsStart: this.params.IsStart == 0 ? false : true,
        });
        this.saveData();
      }
    },
    saveData() {
      let params = Object.assign(this.data);
      params.EndTime = "2077-7-07";
      this.$api.post(`ServiceInfo/addOrEditScuConfig`, params).then((res) => {
        if (res.statusCode == 200) {
          this.$Message.success(res.msg);
        }
        this.clear();
      });
    },
  },
  created() {
    this.LogsData = this.$parent.LogsData;
  },
  mounted() {
    this.getData();
    this.getScuConfig();
  },
};
</script>
<style scoped lang="scss">
.scpPage {
  color: #333;

  .secondOperation {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .status {
      width: 74px;
      height: 74px;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 50%;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 74px;
      text-align: center;
    }
  }

  .line {
    width: 4px;
    height: 18px;
    background: #338bff;
    margin: 0 8px 0 0;
  }

  .first {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 12px 0;
    height: 32px;
    line-height: 32px;

    .tit {
      display: flex;
      align-items: center;
      font-size: 16px;
    }

    .log {
      width: 82px;
      text-align: center;
      background: #f2f7ff;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #338bff;
      cursor: pointer;
      margin: 0 8px 0 0;
    }
  }

  .des {
    display: flex;
    border: 1px solid #e5e5e5;
    padding: 18px 12px;

    .serDes {
      margin: 0 24px 0 0;
    }

    .secondTit {
      color: #666666;
    }
  }

  .second {
    .tit {
      display: flex;
      margin: 26px 0 12px 0;
    }

    .secOperation {
      width: 300px;
      border: 1px solid #e5e5e5;
      padding: 10px;

      .btnGroup {
        .cancel {
          margin: 0 10px 0 90px;
        }
      }
    }
  }
}
</style>
<style>
.scpPage .ivu-form-item {
  margin-bottom: 12px;
}
</style>